import Vue from "vue";
// 全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
// 指令名称为：real-img
Vue.directive("real-img", async (el, binding) => {
  const imgURL = binding.value; // 获取图片地址
  const defaultURL = el.getAttribute("default-img"); // 获取默认图片地址
  const defaultImgWidth = el.getAttribute("default-img-width"); // 获取默认图片地址
  if (imgURL) {
    const exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute("src", imgURL);
    } else {
      if (defaultURL) {
        el.setAttribute("src", defaultURL);
        defaultImgWidth &&
        (el.style.width = defaultImgWidth + "px") &&
        (el.style.height = defaultImgWidth + "px");
      }
    }
  } else {
    el.setAttribute("src", "");
  }
});

/**
 * 检测图片是否存在
 * @param url
 */
const imageIsExist = (url: string) => {
  return new Promise(resolve => {
    let img: any = new Image();
    img.onload = function() {
      if (this.complete === true) {
        resolve(true);
        img = null;
      }
    };
    img.onerror = () => {
      resolve(false);
      img = null;
    };
    img.src = url;
  });
};
